/**
 * Sysnet API
 *  ## Authorization We use bearer auth throughout the API. Generally, API requests should have the follow header:   {       \"content-type\": \"application/json\",       \"Authorization\": \"Bearer TOKEN_GOES_HERE\"   }   Please refer to the Auth section immediately below for details on getting your token.
 *
 * OpenAPI spec version: 1.0.4
 * Contact: support@hlpos.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ReportPeriodHeaderInsert { 
    /**
     * Foreign key referencing the venue.
     */
    venueId: string;
    /**
     * Start date of the period.
     */
    startDate: Date;
    /**
     * End date of the period.
     */
    endDate?: Date;
    /**
     * Type of the period.
     */
    periodType: ReportPeriodHeaderInsert.PeriodTypeEnum;
    /**
     * Label for the period.
     */
    label?: string;
    /**
     * Indicates if it is the actual end of day.
     */
    actualEod?: boolean;
    /**
     * Week number of the period.
     */
    weekNo?: number;
    /**
     * Year of the period.
     */
    year?: number;
    /**
     * Quarter of the year.
     */
    quarter?: number;
    /**
     * The unique external key set by the current user accessing the API
     */
    externalKey?: string;
}
export namespace ReportPeriodHeaderInsert {
    export type PeriodTypeEnum = 'Day' | 'Week' | 'Month' | 'Year';
    export const PeriodTypeEnum = {
        Day: 'Day' as PeriodTypeEnum,
        Week: 'Week' as PeriodTypeEnum,
        Month: 'Month' as PeriodTypeEnum,
        Year: 'Year' as PeriodTypeEnum
    };
}